import CRMStatusChip from '@components/Common/CRMStatusChip';
import React from 'react';

/** Yes, No, or a dash when the site did not say. One rendering for the list and the record. */
const YesNo: React.FC<{ on: boolean | null }> = ({ on }) =>
  on === null ? (
    <>-</>
  ) : (
    <CRMStatusChip
      status={on ? 'active' : 'inactive'}
      label={on ? 'Yes' : 'No'}
    />
  );

export default YesNo;
